import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { routes, getRedirect } from './routingDefinitions';
import RouteExternal from './RouteExternal';
import AuthenticatedRoute from '../../pages/AuthenticatedRoute';
import UnauthenticatedRoute from '../../pages/UnauthenticatedRoute';
import ROUTES from './constants';
import LOCALSTORAGE from '../../_shared/constants/localStorage';
import { expireCookie, getCookie } from '../../_shared/utils/cookies';
import { COOKIES } from '../../_shared/constants/cookies';

function Routes() {
  const { pathname } = useLocation();
  let redirectRoute = getRedirect(pathname);
  if (getCookie(COOKIES.SHOULD_REDIRECT_OMP) === 'false') {
    sessionStorage.setItem(LOCALSTORAGE.SHOULD_REDIRECT_OMP, 'false');
    expireCookie(COOKIES.SHOULD_REDIRECT_OMP);
  }

  if (redirectRoute?.path === ROUTES.PAYMENTS_ON_HOLD) {
    redirectRoute = null;
  }
  // TIAH routes redirect unless dev toggle is on
  if (process.env.REACT_APP_SHOW_TIAH === 'true') {
    if (
      [
        ROUTES.TIAH,
        ROUTES.TIAH_DEALER_MAP,
        ROUTES.TIAH_MOBILE_NUMBER,
        ROUTES.TIAH_MOBILE_VERIFICATION
      ].includes(redirectRoute?.path)
    ) {
      redirectRoute = null;
    }
  }

  return (
    <Switch>
      {redirectRoute &&
        (redirectRoute.tr4 ? (
          <RouteExternal
            exact
            path={redirectRoute.path}
            link={redirectRoute.to}
          />
        ) : (
          <Redirect exact from={redirectRoute.path} to={redirectRoute.to} />
        ))}
      {routes.map(({ path, authenticated, Component }) => (
        <Route path={path} key={path}>
          {(() => {
            switch (authenticated) {
              case true:
                return <AuthenticatedRoute component={Component} />;
              case false:
                return <UnauthenticatedRoute component={Component} />;
              default:
                return <Component />;
            }
          })()}
        </Route>
      ))}
    </Switch>
  );
}

export default Routes;
